'use es6';

import http from 'hub-http/clients/apiClient';
const generateHublEndpoint = 'designmanager/v1/sections/generate-hubl';
export function fetchHubl(sectionTree) {
  return http.post(generateHublEndpoint, {
    data: sectionTree
  });
}